import React from 'react'
import { Card, Button,  } from 'react-bootstrap';
import '../mysass.scss';

const Airport = () => {
  return (
<>
<Card className="bg-dark text-white">
      <Card.Img src="airport.jpg" alt="Card image" style={{height:'400px',objectFit:'cover',}} />
      <Card.ImgOverlay>
        <Card.Text className='card2' style={{fontFamily:'Black Ops One, cursive'}}>
           KOSOVO INTERNATIONAL AIRPORT "ADEM JASHARI"
        </Card.Text>
        <p className='airportparagraph' style={{textAlign:'center'}}>
        "Prishtina Airport Adem Jashari" is an airport near Prishtina, the capital of Kosovo. 
        It is located around 15 kilometers southwest of the city near the M-9 km of 
        the Prishtine-Peje highway.
        </p>
        <Card.Text className='buttonairport' style={{ position: 'absolute', bottom: '10px', left: '50%', transform: 'translateX(-50%)'}}>
              <Button variant="outline-light" href='https://www.limakkosovo.aero/' target="_blank" style={{fontSize:'16px',}}>Click here for more about flights and info about the airport:</Button>
      </Card.Text>
      </Card.ImgOverlay>
    </Card>
</>
  )
}

export default Airport